import { render, staticRenderFns } from "./CAxACGxAttentionPage.vue?vue&type=template&id=f3b0254c"
import script from "./CAxACGxAttentionPage.vue?vue&type=script&lang=js"
export * from "./CAxACGxAttentionPage.vue?vue&type=script&lang=js"
import style0 from "./CAxACGxAttentionPage.vue?vue&type=style&index=0&id=f3b0254c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports